<template>
  <div class="data-table-container">
    <!-- <p>{{ Object.keys(assignments) }}</p> -->
    <!-- <p>{{ pirSummaryToUseIds }}</p> -->
    <!-- <p>{{ selectedFilters }}</p> -->
    <v-dialog
      v-model="showAttachement"
      persistent
      max-width="500"
      height="auto"
    >
      <v-card height="auto">
        <v-card-text>
          <div class="pt-5">
            <h3>New Row</h3>
            <div class="mt-4">
              <SingleDimensionsPicker
                :selectionOptionsForDimension.sync="addnewRowValueSelected"
                :itemIdsToNotFetch="itemIdsToNotFetch"
                :multiple="true"
                @update:selectionOptionsForDimension="
                  (value) => updateNewRowValueFromSingleDimensionSelector(value)
                "
              />
            </div>
            <div class="text-right">
              <v-btn
                color="red"
                text
                small
                :disabled="deployingPortfolio || updatingPortfolio"
                @click="closeAddNewRowModal"
                >Close</v-btn
              >
              <v-btn
                color="primary"
                class="ml-3"
                small
                :disabled="deployingPortfolio || updatingPortfolio"
                @click="processAddNewRow"
                >Add</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ConfirmationModal
      :dialog="showConfimationModal"
      :okaction="okAction"
      :message="confirmationModalMessage"
      :header="confirmationModalHeader"
      @cancel="showConfimationModal = false"
      @ok="processConfirmationModal"
      :okloading="deployingPortfolio"
    />
    <v-expansion-panels flat accordion class="ml-n6 mt-5">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h2>Analyst Effort Summary</h2>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col
              v-for="(analyst, i) in analystEffortSummary"
              :key="i"
              cols="2"
            >
              <v-card>
                <v-card-text>
                  <v-row class="d-flex">
                    <v-col cols="auto">
                      <p class="font-weight-bold">Name</p>
                      <p>{{ analyst.givenName }}</p>
                    </v-col>
                    <v-col cols="auto">
                      <p class="font-weight-bold">Count</p>
                      <p>{{ getAnalystEffortCount(analyst) }}</p>
                    </v-col>
                    <v-col cols="auto">
                      <p class="font-weight-bold">Workload</p>
                      <p>{{ getAnalystEffortWorkload(analyst) }}</p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <h2 class="mt-4">Portfolio Management</h2>
    <!-- <p>{{ allAnalystOptions }}</p> -->
    <!-- <p>{{ selectedFilters }}</p> -->
    <v-row class="mb-n7 mt-4 align-center" justify="space-between">
      <v-col cols="auto">
        <p class="mb-n1">History</p>
        <div class="mt-2">
          <PirHistoryPicker
            :key="refreshHistoryFromServerKey"
            @setNewHistoryItem="(v) => (setNewHistoryItem = v)"
            @update:canEnterNewValues="(value) => (canEnterNewValues = value)"
            @update:currentItem="(value) => saveCurrentActivePortfolio(value)"
            @update:pirManageMode="(value) => (pirManageModeValue = value)"
            :documentToFetchDates="documentToFetchDates"
            @fetchavailableDates="(v) => (refreshHistoryFromServer = v)"
            :variablesToFetchDates="variablesToFetchDates"
            queryToReadData="collectionPortfolios"
          />
        </div>
      </v-col>
      <v-col cols="auto" class="d-flex align-center">
        <p v-if="deployedDate" class="mr-5 mt-4 font-italic">
          Last deployed: {{ formatDate(deployedDate, "ddd D MMM YYYY") }}
        </p>
        <v-btn
          v-if="hasPermission(['manage-portfolio']) && !deployedDate"
          color="red"
          class="mr-3"
          text
          outlined
          :loading="deployingPortfolio"
          @click="triggerPortfolioDeploy"
          >Deploy</v-btn
        >
        <v-btn
          v-if="hasPermission(['manage-portfolio']) && pirManageModeValue"
          color="primary"
          :loading="updatingPortfolio"
          @click="updatePortfolio"
          >{{ processButtonText }}</v-btn
        >
      </v-col>
    </v-row>
    <v-row class="d-flex align-center mt-4 justify-space-between">
      <v-col cols="12" class="d-flex">
        <div v-for="(filterOption, i) in filterOptions" :key="i">
          <v-autocomplete
            v-if="filterOption.type === 'autocomplete'"
            dense
            clearable
            :items="filterOption.options"
            class="mr-3"
            v-model="selectedFilters[filterOption.key]"
            item-text="label"
            multiple
            item-value="value"
            :label="filterOption.title"
            outlined
            ></v-autocomplete>
            <v-text-field
            v-else-if="filterOption.type === 'textfield'"
            outlined
            :label="filterOption.title"
            class="mr-3"
            dense
            v-model="selectedFilters[filterOption.key]"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <div class="text-right">
      <v-btn
        color="red"
        class="mb-2"
        text
        small
        style="text-transform: none"
        :disabled="deployingPortfolio || updatingPortfolio"
        @click="addNewRow"
        >New Row</v-btn
      >
    </div>
    <table class="data-table">
      <!-- Grouped Header Rows -->
      <thead>
        <tr class="header-group-row">
          <th colspan="4" class="header-group pir-group">PIR</th>
          <th colspan="7" class="header-group analysts-group">Analysts</th>
        </tr>
        <tr class="header-detail-row">
          <th v-for="header in headers" :key="header.key" class="header-cell">
            {{ header.title }}
          </th>
        </tr>
      </thead>
      <div v-if="pirSummaryToDisplay.length === 0" class="text-center mt-15 pt-15">No data to view</div>
      <tbody>
        <tr
          v-for="(pir, rowIndex) in pirSummaryToDisplay"
          :key="rowIndex"
          class="data-row"
        >
          <td
            v-for="(cell, colIndex) in headers"
            :key="colIndex"
            :class="[
              'data-cell',
              colIndex < 4 ? 'readonly-cell' : 'editable-cell',
              isNewRow(pir) ? 'new-cell' : '',
            ]"
          >
            <template
              v-if="regions.includes(cell.key)"
              class="d-flex align-center"
            >
              <div class="d-flex align-center">
                <div class="ma-4">
                  {{ getAssignedAnalyst(pir, cell.key) }}
                </div>
                <v-menu
                  v-if="hasPermission(['manage-portfolio'])"
                  offset-y
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="ml-auto">
                      <v-btn
                        @click="searchAnalystToDisplay = null"
                        x-small
                        icon
                        :disabled="!canWrite"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>mdi-account-multiple</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-card min-height="auto" max-height="300">
                    <div class="pa-2 mb-n7">
                      <v-text-field
                        dense
                        v-model="searchAnalystToDisplay"
                        placeholder="Search"
                        outlined
                      ></v-text-field>
                    </div>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in analysts"
                        :key="index"
                        dense
                        value
                        color="primary"
                        :input-value="isActiveAnalyst(item, pir, cell.key)"
                        @click="assignAnalyst(item, pir, cell.key)"
                      >
                        <v-list-item-title>{{
                          item.node.givenName
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-else-if="cell.key === 'comments'">
              <input
                v-if="hasPermission(['manage-portfolio'])"
                type="text"
                :disabled="!canWrite"
                :value="getComment(pir)"
                @change="
                  (event) => onCellChange(event.target.value, pir, 'comments')
                "
                class="cell-input"
              />
            </template>
            <template
              v-else-if="['assignedPriority', 'effort'].includes(cell.key)"
              class="d-flex align-center"
            >
              <div class="d-flex align-center">
                <div class="ma-4">
                  {{ getCellValueFromPirAssignment(pir, cell.key) }}
                </div>
                <v-menu v-if="hasPermission(['manage-portfolio'])" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="ml-auto">
                      <v-btn
                        @click="searchAnalystToDisplay = null"
                        x-small
                        icon
                        :disabled="!canWrite"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>mdi-check-all</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-card min-height="auto" max-height="300">
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in priorities"
                        :key="index"
                        dense
                        value
                        color="primary"
                        @click="onCellChange(item, pir, cell.key)"
                        :input-value="
                          getCellValueFromPirAssignment(pir, cell.key) === item
                        "
                      >
                        <v-list-item-title>{{ item }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-else-if="cell.key === 'complexity'">
              <span class="readonly-text">{{ pir.completxityScore }}</span>
            </template>
            <template v-else-if="cell.key === 'clients'">
              <div class="d-flex align-center">
                <v-menu offset-y open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      style="cursor: pointer"
                      v-html="getClientsAndPriority(pir)"
                      class="ma-4"
                    ></div>
                  </template>
                  <v-card min-height="auto" max-height="300">
                    <ClientsDetailsTable :clients="getPIRClients(pir)" />
                  </v-card>
                </v-menu>
                <v-menu
                  v-if="hasPermission(['manage-portfolio'])"
                  offset-y
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="ml-auto">
                      <v-btn
                        x-small
                        icon
                        :disabled="!canWrite"
                        v-bind="attrs"
                        v-on="on"
                        @click="triggerOpenAddNewClientsToPir(pir)"
                      >
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-card min-height="auto" max-height="400" width="400">
                    <v-card-text>
                      <p class="font-weight-bold">Add clients</p>
                      <CompanySelector
                        :companySelected.sync="newlySelectedCompanies[pir.id]"
                        :id="`companySelector-${pir.id}`"
                        :showTeamsSelector="true"
                        :multiple="true"
                        :readonlyMode="newlySelectedCompaniesSaving[pir.id]"
                        :companyIdsToNotFetch="getPIRClientsIds(pir)"
                        :withSubscriptionOnly="true"
                        :returnObject="true"
                      />
                      <!-- :subscriptionTypeToFind="subscriptionTypeToFind" -->

                      <div class="text-right">
                        <v-btn
                          color="primary"
                          @click="triggerSaveAddNewClientsToPir(pir)"
                          class="ml-3"
                          :loading="newlySelectedCompaniesSaving[pir.id]"
                          small
                          >Save</v-btn
                        >
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-else>
              <div class="d-flex align-center">
                <span class="readonly-text">{{ pir[cell.key] }}</span>
                <span v-if="cell.key === 'type' && isNewRow(pir)">
                  <v-btn color="red" x-small icon @click="deleteNewRowPir(pir)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </span>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CompanySelector from "@/components/shared/companySelector.vue";
import {
  addPirToCompanyRequirementsMutation,
  CollectionPortfoliosDocument,
  CollectionPortfolioSortFields,
  createOneCollectionPortfolioMutation,
  SortDirection,
  updateAdUsersPirAssignmentsMutation,
  updateOneCollectionPortfolioMutation,
  useAdUsersQuery,
  useGetPortfolioPirRequirementsQuery,
} from "@/graphql/jarvis";
import SingleDimensionsPicker from "@/components/shared/singleDimensionsPicker.vue";
import PirHistoryPicker from "@/components/pir/PirHistoryLoader.vue";
import { Priority } from "@/types/misc";
import { groupBy, orderBy, sum, uniq } from "lodash";
import moment from "moment";
import { commonMixins } from "@/mixins/common";
import ClientsDetailsTable from "@/components/portfolioManagement/clientsDetailsTable.vue";
import { PirManageMode } from "@/utils/misc";
import ConfirmationModal from "@/components/confirmationModal.vue";
import { locationFormatter } from "@/utils/post";
import { mapGetters } from "vuex";

const classForRemovedClient = "text-strikethrough";

// calculate the priority as SUM (company values: 1 for "monitored", 3 for "priority")
// complexity (low (1), medium (2), high (3), very hard (5)).

const priorityComplexityMarks = {
  [Priority.UNMONITORED]: 0,
  [Priority.MONITORED]: 1,
  [Priority.PRIORITY]: 3,
};

// ["Information", "Enhanced", "Insight", "Foresight"];

const subscriptionAccessLevelMarks = {
  Information: 1,
  Enhanced: 1.5,
  Insight: 2,
  Foresight: 3,
};

const effortScore = {
  low: 1,
  medium: 2,
  high: 3,
  ["very hard"]: 4,
};

function mergePIRs(pirs1, pirs2) {
  // Combine both arrays
  const all = [...pirs1, ...pirs2];
  // Use a Map to accumulate unique dimensions
  const dimMap = new Map();
  all.forEach((dim) => {
    if (!dimMap.has(dim.id)) {
      dimMap.set(dim.id, {
        ...dim,
        clients: [...dim.clients],
      });
    } else {
      const existing = dimMap.get(dim.id);
      // Build a quick lookup of existing client‑ids
      const seen = new Set(existing.clients.map((c) => c.id));
      // Add any new clients from this dim
      dim.clients.forEach((c) => {
        if (!seen.has(c.id)) {
          existing.clients.push(c);
          seen.add(c.id);
        }
      });
    }
  });
  return Array.from(dimMap.values());
}

const regions = ["NORAM", "EMEA", "APAC", "LATAM"];

const defaultVariables = {
  filter: {},
  sorting: [
    {
      field: CollectionPortfolioSortFields.Updated,
      direction: SortDirection.Desc,
    },
    {
      field: CollectionPortfolioSortFields.Id, // to prevent returning duplicates
      direction: SortDirection.Desc,
    },
  ],
};

export default {
  name: "DataTable",
  mixins: [commonMixins],
  components: {
    ClientsDetailsTable,
    PirHistoryPicker,
    ConfirmationModal,
    SingleDimensionsPicker,
    CompanySelector,
  },
  data() {
    return {
      newlySelectedCompanies: {},
      newlySelectedCompaniesSaving: {},
      newRowsToBeSaved: [], // this holds the formatted pir values for dimensions newly added (they are not pir yet)
      sortingConfig: {
        weighting: "desc",
        type: "asc",
        value: "asc",
      },
      // add new row modal details start
      showAttachement: false,
      addnewRowValueSelected: [], // this hold raw dimensions selected from the SingleDimensionsPicker on the modal
      // add new row modal details end
      refreshHistoryFromServerKey: 1,
      // for confirmation modal start
      okAction: "",
      confirmationModalMessage: "",
      confirmationModalHeader: "",
      showConfimationModal: false,
      // for confirmation modal end
      // history props start
      setNewHistoryItem: null,
      currentPortfolio: null,
      canEnterNewValues: true,
      pirManageModeValue: null,
      documentToFetchDates: CollectionPortfoliosDocument,
      variablesToFetchDates: {
        ...defaultVariables,
      },
      refreshHistoryFromServer: null,
      // history props end
      regions: regions,
      selectedFilters: {},
      priorities: ["very High", "high", "medium", "low"],
      loadingCollectionPortfolios: false,
      updatingPortfolio: false,
      deployingPortfolio: false,
      searchAnalystToDisplay: null,
      loadingPirAggregates: false,
      assignments: {}, // [pirId]: { comments: '', [APAC]: [analysts]}
      headers: [
        {
          title: "Type",
          key: "type",
        },
        {
          title: "Value",
          key: "name",
        },
        {
          title: "Clients",
          key: "clients",
        },
        {
          title: "Weighting",
          key: "complexity",
        },
        {
          title: "Priority",
          key: "assignedPriority",
        },
        {
          title: "Effort",
          key: "effort",
        },
        ...regions.map((region) => {
          return {
            title: region,
            key: region,
          };
        }),
        {
          title: "Comments",
          key: "comments",
        },
      ],
    };
  },
  apollo: {
    adUsers: {
      ...useAdUsersQuery(),
    },
    getPortfolioPIRRequirements: {
      ...useGetPortfolioPirRequirementsQuery({
        variables: {},
        fetchPolicy: "network-only",
      }),
      watchLoading(isLoading) {
        this.$store.commit("queryLoading", isLoading);
        this.loadingPirAggregates = isLoading;
      },
    },
  },
  computed: {
    pirSummaryToUseIds() {
      return this.originalPirSummaryToUse.map((x) => x?.id).filter((x) => x.length);
    },
    itemIdsToNotFetch() {
      let items = {};
      for (const item of this.pirSummaryToDisplay) {
        const type = item?.type;
        if (!type) continue;
        const oldItems = items?.[type] ?? [];
        oldItems.push(item.id);
        items = {
          ...items,
          [type]: oldItems,
        };
      }
      return items;
    },
    deployedDate() {
      return this.currentPortfolio?.deployDate
        ? this.currentPortfolio.deployDate
        : null;
    },
    processButtonText() {
      return this.pirManageModeValue;
    },
    canWrite() {
      return this.canEnterNewValues;
    },
    ...mapGetters("adUsers", ["getAdUsersByRole"]),
    allAnalystOptions() {
      // console.log('getAdUsersByRole', this.getAdUsersByRole([]));
      // const allEntries = Object.values(this.assignments).flatMap(
      //   (regionBlock) =>
      //     Object.values(regionBlock)
      //       // filter out non‑arrays
      //       .filter((v) => Array.isArray(v))
      //       .flat()
      // );

      // // 2. Dedupe by email:
      // const seen = new Set();
      // const uniqueByEmail = allEntries.filter((item) => {
      //   if (seen.has(item.email)) return false;
      //   seen.add(item.email);
      //   return true;
      // });

      // 3. Map down to only the fields you want:
      return this.getAdUsersByRole([]).map(({ email, name }) => ({
        value: email,
        label: name,
      }));
    },
    filterOptions() {
      return [
        {
          title: "Search",
          key: "search",
          type: "textfield",
        },
        {
          title: "Type",
          key: "types",
          options: this.typeFilterOptions,
          type: "autocomplete",
        },
        {
          title: "Client",
          key: "clients",
          options: (this.pirsCompanies || []).map((c) => {
            return {
              value: c.id,
              label: c.name,
            };
          }),
          type: "autocomplete",
        },
        {
          title: "Analyst",
          key: "analysts",
          options: this.allAnalystOptions,
          type: "autocomplete",
        },
        {
          title: "Priority",
          key: "priorities",
          options: this.priorities,
          type: "autocomplete",
        },
      ];
    },
    typeFilterOptions() {
      return uniq(this.originalPirSummaryToUse.map((x) => x.type));
    },
    // collectionPortfoliosComputed() {
    //   return this.collectionPortfolios?.edges || [];
    // },
    analysts() {
      const items = this.adUsers?.edges || [];
      let options = [...items];
      const query = (this.searchAnalystToDisplay || "").trim().toLowerCase();
      if (query) {
        options = items.filter(({ node }) => {
          const email = (node.email || "").toLowerCase();
          return email.includes(query);
        });
      }
      return orderBy(options, ["node.givenName", "desc"]);
    },
    pirAggregatesComputed() {
      const items = this.getPortfolioPIRRequirements || {};
      return items;
    },
    // this is the newest pir from getPortfolioPIRRequirements query
    latestPir() {
      return this.pirAggregatesComputed?.pirs || [];
    },
    // this is pir from last create portfolio
    oldPortfolioPirSummary() {
      return (
        this.currentPortfolio?.pirSummary?.pirs || []
        // this.collectionPortfoliosComputed?.[0]?.node?.pirSummary?.pirs || []
      );
    },
    analystEffortSummary() {
      const analystsFormatted = {};
      // NOTE: completxityScore here means complexity score
      for (const [pirId, portfolio] of Object.entries(this.assignments)) {
        if (!portfolio) continue;

        for (const region of regions) {
          const analysts = portfolio[region] || [];

          analysts.forEach((analyst) => {
            const email = analyst.email;
            if (!email) return;

            // 1) Ensure top‑level record exists
            if (!analystsFormatted[email]) {
              analystsFormatted[email] = {
                email,
                fullName: analyst.analyst,
                givenName: analyst.givenName,
                pirsScores: {},
              };
            }

            // 2) Ensure pirsScores[pirId] bucket exists
            const scores = analystsFormatted[email].pirsScores;
            if (!scores[pirId]) {
              scores[pirId] = {
                analystsEfforts: 0,
                regionAssigned: [],
                priorities: 0,
                completxityScore: 0,
              };
            }

            // 3) Push into each array if present
            if (portfolio.effort)
              scores[pirId].analystsEfforts = effortScore[portfolio.effort];
            if (analyst.regionAssigned)
              scores[pirId].regionAssigned.push(analyst.regionAssigned);
            if (portfolio.assignedPriority)
              scores[pirId].priorities =
                effortScore[portfolio.assignedPriority];

            // 4) Lookup and push completxityScore
            const complexity =
              this.pirSummaryToDisplay.find((x) => x.id === pirId)
                ?.completxityScore || 0;
            scores[pirId].completxityScore = complexity;
          });
        }
      }

      return Object.values(analystsFormatted);

      //
    },
    pirSummaryToDisplay() {
      let data = mergePIRs(this.oldPortfolioPirSummary, this.latestPir);
      // console.log('this.oldPortfolioPirSummary', this.oldPortfolioPirSummary);
      // console.log('this.latestPir', this.latestPir);
      // console.log('data', data);
      // add newRowsToBeSaved if it exist
      data = data.concat(this.newRowsToBeSaved ?? []);
      data = data.map((x) => {
        const completxityScore = this.calculateComplexityScore(x.clients, x);
        return {
          ...x,
          completxityScore,
        };
      });
      data = this.applyFiltersToPirSummaryToUse(data);
      data = this.applySortingToPirSummaryToUse(data);
      return data;
    },
    originalPirSummaryToUse() {
      // this isnt affected by filters and hold all the original pirSummaryToDisplay
      let data = mergePIRs(this.oldPortfolioPirSummary, this.latestPir);
      data = data.concat(this.newRowsToBeSaved ?? []);
      data = data.map((x) => {
        const completxityScore = this.calculateComplexityScore(x.clients, x);
        return {
          ...x,
          completxityScore,
        };
      });
      return data;
    },
    pirsCompanies() {
      return this.pirAggregatesComputed?.companies || [];
    },
  },
  methods: {
    isNewRow(pir) {
      const id = pir?.id;
      const type = pir?.type;
      const itsNewRowIndex = this.newRowsToBeSaved
        .map((x) => `${x.id}_${x.type}`)
        .indexOf(`${id}_${type}`);
      return itsNewRowIndex >= 0;
    },
    async deleteNewRowPir(pir) {
      const id = pir?.id;
      const type = pir?.type;
      const itsNewRowIndex = this.newRowsToBeSaved
        .map((x) => `${x.id}_${x.type}`)
        .indexOf(`${id}_${type}`);
      if (itsNewRowIndex < 0) return;
      const collectionPortfolio = await this.getCollectionPortfolioToSubmit();
      const documentToUse = updateOneCollectionPortfolioMutation;
      // remove the item from collectionPortfolio?.portfolio?.dimensions
      let dimensions = collectionPortfolio?.portfolio?.dimensions || [];
      dimensions = [...dimensions].filter(
        (x) => !(x?.dimensionId === id && x?.dimensionType === type)
      );
      const collectionPortfolioFormatted = {
        ...(collectionPortfolio || {}),
        portfolio: {
          ...(collectionPortfolio?.portfolio || {}),
          dimensions,
        },
      };
      const variables = {
        input: {
          id: this.currentPortfolio?.id,
          update: collectionPortfolioFormatted,
        },
      };
      const { success } = await documentToUse(this, {
        variables,
      });
      if (success) {
        // also remove the item from newRowsToBeSaved
        const items = this.newRowsToBeSaved.filter(
          (x) => !(x?.id === id && x?.type === type)
        );
        this.$set(this, "newRowsToBeSaved", items);
        if (this.refreshHistoryFromServer) this.refreshHistoryFromServer();
        ++this.refreshHistoryFromServerKey;
      }
    },
    triggerOpenAddNewClientsToPir(pir) {
      this.$set(this.newlySelectedCompanies, pir.id, []);
    },
    async removeCollectionPorfoliosById(id, type, pirSummary) {
      const itsNewRowIndex = this.newRowsToBeSaved
        .map((x) => `${x.id}_${x.type}`)
        .indexOf(`${id}_${type}`);
      if (itsNewRowIndex < 0) return;
      const data = (pirSummary?.pirs || []).find(
        (x) => x.id === id && x.type === type
      );
      if (!data) return;
      this.newRowsToBeSaved.splice(itsNewRowIndex, 1, data);
      this.updatePortfolio();
      const items = this.newRowsToBeSaved.filter(
        (x) => !(x.id === id && x.type === type)
      );
      this.$set(this, "newRowsToBeSaved", items);
    },
    async triggerSaveAddNewClientsToPir(pir) {
      const clients = this.newlySelectedCompanies[pir.id] || [];
      if (!clients.length) return;
      const pirRelation = {
        dateAdded: moment().format("YYYY-MM-DD"),
        dimension: pir.type,
        dimensionId: pir.id,
        priority: Priority.MONITORED,
      };
      const clientIds = clients
        .map((x) => x?.node?.id)
        .filter((x) => x?.length);
      try {
        const variables = {
          pirRelation,
          clientIds,
        };
        this.$set(this.newlySelectedCompaniesSaving, pir.id, true);
        const { success, data } = await addPirToCompanyRequirementsMutation(
          this,
          {
            variables,
          }
        );
        if (success) {
          const pirSummary = data?.addPIRToCompanyRequirements;
          await this.$apollo.queries.getPortfolioPIRRequirements.refetch();
          await this.removeCollectionPorfoliosById(
            pir.id,
            pir.type,
            pirSummary
          );
          this.$store.commit("showMessage", {
            content: `Company added successfuly!`,
            color: "green",
            timeout: 6000,
          });
        }
        // whenever clients is done saving, we have to remove the pir id from the newlySelectedCompanies
      } catch (error) {
        //
      } finally {
        this.$set(this.newlySelectedCompaniesSaving, pir.id, false);
      }
    },
    closeAddNewRowModal() {
      this.addnewRowValueSelected = [];
      this.showAttachement = false;
    },
    processAddNewRow() {
      const items = [];
      for (const x of this.addnewRowValueSelected) {
        const item = x?.node;
        console.log("item", item);
        if (!item || !item?.id) continue;
        const itemF = {
          type: item.type,
          name:
            item?.type === "Location"
              ? locationFormatter({ node: item })
              : item.name,
          id: item.id,
          clients: [],
          __typename: "PIRDimension",
        };
        items.push(itemF);
      }
      this.newRowsToBeSaved.push(...items);
      this.showAttachement = false;
      this.addnewRowValueSelected = [];
    },
    updateNewRowValueFromSingleDimensionSelector(value) {
      this.addnewRowValueSelected = value;
    },
    addNewRow() {
      this.showAttachement = true;
    },
    applySortingToPirSummaryToUse(data) {
      let dataCopy = [...(data || [])];
      for (const key in this.sortingConfig) {
        if (key === "weighting" && this.sortingConfig?.[key]) {
          dataCopy = orderBy(
            dataCopy,
            ["completxityScore"],
            [this.sortingConfig?.[key]]
          );
        }
        if (key === "type" && this.sortingConfig?.[key]) {
          dataCopy = orderBy(dataCopy, ["type"], [this.sortingConfig?.[key]]);
        }
        if (key === "value" && this.sortingConfig?.[key]) {
          dataCopy = orderBy(dataCopy, ["id"], [this.sortingConfig?.[key]]);
        }
      }
      return dataCopy;
    },
    processConfirmationModal() {
      if (this.okAction === "deployPortfolio") {
        this.deployPortfolio();
      }
    },
    getAnalystEffortCount(effort) {
      const regions = [];
      for (const item of Object.values(effort?.pirsScores || {})) {
        const regionAssigned = item?.regionAssigned || [];
        regions.push(...regionAssigned);
      }
      return regions?.length;
    },
    getAnalystEffortWorkload(effort) {
      const pirItemsToSum = [];
      for (const item of Object.values(effort?.pirsScores || {})) {
        // calculating items per pir
        const completxityScore = item?.completxityScore || 0;
        const analystsEfforts = item?.analystsEfforts || 0;
        const regionAssigned = item?.regionAssigned || [];
        const score =
          completxityScore * analystsEfforts * regionAssigned.length;
        // push each pir score to the pirItemsToSum
        pirItemsToSum.push(score);
      }
      // return the sum of the pir scores
      return sum(pirItemsToSum);
    },
    calculateComplexityScore(clients = [], pir) {
      const score = clients.reduce((accumulator, client) => {
        let clientScore = 0;
        let subscriptionsAccessLevelsScore = 0;
        const clientIsRemoved = (
          this.getClientStatusColor(client, pir) || ""
        ).includes(classForRemovedClient);
        if (!clientIsRemoved) {
          // get client sub access level score start
          const clientDetails = this.pirsCompanies.find(
            (c) => c?.id === client?.id
          );
          subscriptionsAccessLevelsScore = sum(
            (clientDetails?.subscriptions || []).map(
              (x) => subscriptionAccessLevelMarks[x.type]
            )
          );
          // get client sub access level score end
        }
        clientScore =
          (priorityComplexityMarks?.[client.priority] || 0) *
          subscriptionsAccessLevelsScore;
        return accumulator + clientScore;
      }, 0);
      return score;
    },
    saveCurrentActivePortfolio(value) {
      // if any item (with; dimensionId and dimensionType) in the currentPortfolio?.portfolio?.dimensions
      // doesnt exist in the currentPortfolio?.pirSumary?.pirs (with same: id and type) it means they where added without a company and was a new row
      this.currentPortfolio = value;
      const itemsThatAreNewRows = (
        this.currentPortfolio?.portfolio?.dimensions || []
      ).filter((x) => {
        const key = `${x.dimensionId}-${x.dimensionType}`;
        return !(this.currentPortfolio?.pirSummary?.pirs || [])
          .map((x) => `${x.id}-${x.type}`)
          .includes(key);
      });
      // console.log("itemsThatAreNewRows", itemsThatAreNewRows);
      const newRowsToBeSaved = itemsThatAreNewRows.map((x) => {
        return {
          type: x.dimensionType,
          name: x.name,
          id: x.dimensionId,
          clients: [],
          __typename: "PIRDimension",
        };
      });
      this.$set(this, "newRowsToBeSaved", newRowsToBeSaved);
    },
    applyFiltersToPirSummaryToUse(data = []) {
      let dataCopy = [...data];
      // console.log("selectedFilters", this.selectedFilters);
      // console.log("dataCopy", dataCopy);
      for (const key in this.selectedFilters) {
        if (!this.selectedFilters?.[key].length) continue;
        if (key === "clients") {
          dataCopy = dataCopy.filter((p) => {
            const allPirClient = p?.clients || [];
            return allPirClient.find((x) =>
              this.selectedFilters[key].includes(x.id)
            );
          });
        } else if (key === "types") {
          dataCopy = dataCopy.filter((p) => {
            const type = p?.type;
            return this.selectedFilters[key].includes(type);
          });
        } else if (key === "search") {
          const keyword = (this.selectedFilters?.[key] || "").trim().toLowerCase()
          dataCopy = dataCopy.filter((p) => {
            const name = (p?.name || "").trim().toLowerCase();
            return name.includes(keyword);
          });
        } else if (key === "priorities") {
          dataCopy = dataCopy.filter((p) => {
            const priority = this.getCellValueFromPirAssignment(
              p,
              "assignedPriority"
            );
            return this.selectedFilters[key].includes(priority);
          });
        } else if (key === "analysts") {
          dataCopy = dataCopy.filter((p) => {
            const allAnalystsForPirAcrossAllRegions = [];
            regions.forEach((region) => {
              allAnalystsForPirAcrossAllRegions.push(
                ...(this.getAssignedAnalystList(p, region) || [])
              );
            });
            return allAnalystsForPirAcrossAllRegions.find((x) =>
              this.selectedFilters[key].includes(x.email)
            );
          });
        }
      }
      return dataCopy;
    },
    getCollectionPortfolioToSubmit() {
      const pirSummary = this.pirAggregatesComputed;
      const dimensions = [];
      for (const pirId of this.pirSummaryToUseIds) {
        // for (const pirId in this.assignments) {
        if (!pirId) continue;
        const pirDetails = this.originalPirSummaryToUse.find((x) => x.id === pirId);
        // const regions = ["NORAM", "EMEA", "APAC", "LATAM"];
        const analystsAssingment = [];
        regions.forEach((region) => {
          const regionsItems = this.assignments?.[pirId]?.[region] ?? [];
          for (const analyst of regionsItems) {
            analystsAssingment.push({
              analyst: `${analyst?.givenName} ${analyst?.surname}`,
              email: analyst.email,
              audience: region,
              assigned: analyst?.dateAssigned,
            });
          }
        });
        const portfolioItem = {
          dimensionType: pirDetails.type,
          name: pirDetails?.name,
          dimensionId: pirId,
          complexity: pirDetails?.completxityScore,
          comments: this.assignments?.[pirId]?.comments,
          assignedPriority: this.assignments?.[pirId]?.assignedPriority,
          effort: this.assignments?.[pirId]?.effort,
          assignments: analystsAssingment,
        };
        dimensions.push(portfolioItem);
      }
      return {
        pirSummary,
        portfolio: {
          dimensions,
        },
      };
    },
    triggerPortfolioDeploy() {
      this.confirmationModalMessage = `Are you sure you are ready to deploy this collection? This cannot be undone.`;
      this.confirmationModalHeader = `Deploy Portfolio`;
      this.showConfimationModal = true;
      this.okAction = "deployPortfolio";
    },
    async deployPortfolio() {
      try {
        this.deployingPortfolio = true;
        const collectionPortfolio = await this.getCollectionPortfolioToSubmit();
        const variables = {
          input: {
            id: this.currentPortfolio?.id,
            portfolio: collectionPortfolio?.portfolio || {},
          },
        };
        const documentToUse = updateAdUsersPirAssignmentsMutation;
        const { success } = await documentToUse(this, {
          variables,
        });
        if (success) {
          if (this.refreshHistoryFromServer) this.refreshHistoryFromServer();
          this.$store.commit("showMessage", {
            content: `Portfolio deployed!`,
            color: "green",
            timeout: 6000,
          });
          this.confirmationModalMessage = "";
          this.confirmationModalHeader = "";
          this.showConfimationModal = false;
          this.okAction = "";
          ++this.refreshHistoryFromServerKey;
        }
      } catch (error) {
        //
      } finally {
        this.deployingPortfolio = false;
      }
    },
    async updatePortfolio() {
      console.log("updatePortfolio", 1);
      try {
        let message = "created!";
        this.updatingPortfolio = true;
        const collectionPortfolio = await this.getCollectionPortfolioToSubmit();
        console.log("collectionPortfolio", collectionPortfolio);
        let variables = {
          input: {
            collectionPortfolio,
          },
        };
        let documentToUse = createOneCollectionPortfolioMutation;
        if (this.pirManageModeValue === PirManageMode.update) {
          message = "updated!";
          documentToUse = updateOneCollectionPortfolioMutation;
          variables = {
            input: {
              id: this.currentPortfolio?.id,
              update: collectionPortfolio,
            },
          };
        }
        const { data, success } = await documentToUse(this, {
          variables,
        });
        if (success) {
          if (this.refreshHistoryFromServer) this.refreshHistoryFromServer();
          ++this.refreshHistoryFromServerKey;
          this.$store.commit("showMessage", {
            content: `Portfolio ${message}`,
            color: "green",
            timeout: 6000,
          });
          if (this.pirManageModeValue === PirManageMode.create) {
            const item = data?.createOneCollectionPortfolio || null;
            if (item.id && this.setNewHistoryItem) {
              this.setNewHistoryItem(item);
            }
          }
        }
      } catch (error) {
        //
      } finally {
        this.updatingPortfolio = false;
      }
    },
    getComment(pir) {
      return this.assignments?.[pir.id]?.comments;
    },
    getCellValueFromPirAssignment(pir, cellKey) {
      return this.assignments?.[pir.id]?.[cellKey];
    },
    isActiveAnalyst(analyst, pir, region) {
      const analystDetails = analyst?.node || null;
      if (!analystDetails || !analystDetails?.email) return;
      const selectedAnalysts = this.assignments?.[pir?.id]?.[region] || [];
      return selectedAnalysts.find((a) => a?.email === analystDetails.email);
    },
    assignAnalyst(analyst, pir, region) {
      const analystDetails = analyst?.node || null;
      if (!analystDetails || !analystDetails?.email) return;
      let selectedAnalysts = this.assignments?.[pir?.id]?.[region] || [];
      if (this.isActiveAnalyst(analyst, pir, region)) {
        selectedAnalysts = selectedAnalysts.filter(
          (a) => a?.email !== analystDetails.email
        );
      } else {
        selectedAnalysts.push({
          ...analystDetails,
          regionAssigned: region,
          dateAssigned: moment.utc().format("YYYY-MM-DD"),
        });
      }
      this.onCellChange(selectedAnalysts, pir, region);
    },
    getAssignedAnalystList(pir, region) {
      const selectedAnalysts = this.assignments?.[pir?.id]?.[region] || [];
      return selectedAnalysts;
    },
    getAssignedAnalyst(pir, region) {
      const selectedAnalysts = this.getAssignedAnalystList(pir, region);
      return selectedAnalysts.map((x) => x.givenName).join(", ");
    },
    pirClientExist(pirList, clientId, pirid) {
      const pirExistInList = pirList.find((x) => x.id === pirid);
      if (!pirExistInList) return false;
      const clients = pirExistInList?.clients || [];
      return !!clients.find((x) => x.id === clientId);
    },
    getClientStatusColor(client, pir) {
      if (!this.oldPortfolioPirSummary.length) return "grey--text";
      // this checks if a client is new or was removed by comparing latestPir and oldPortfolioPirSummary clients
      // if a client is in oldPortfolioPirSummary and not in latestPir, it means they were removed color should be red
      // if a client is in latestPir and not in oldPortfolioPirSummary, it means they were added color should be green
      let color = "grey";
      let textDecoration = "";
      const existInOldPortfolioPirSummary = this.pirClientExist(
        this.oldPortfolioPirSummary,
        client?.id,
        pir?.id
      );
      const existInLatestPir = this.pirClientExist(
        this.latestPir,
        client?.id,
        pir?.id
      );
      if (!existInOldPortfolioPirSummary && existInLatestPir) color = "green";
      if (existInOldPortfolioPirSummary && !existInLatestPir) {
        color = "red";
        textDecoration = classForRemovedClient;
      }
      return `${textDecoration} ${color}--text`;
    },
    getPIRClientsIds(pir) {
      const clients = pir?.clients || [];
      return clients.map((client) => {
        return client?.id;
      });
    },
    getPIRClients(pir) {
      const clients = pir?.clients || [];
      return clients.map((client) => {
        const clientDetails = this.pirsCompanies.find(
          (c) => c?.id === client?.id
        );
        const name = clientDetails?.name || "Client";
        const subscriptions = clientDetails?.subscriptions || [];
        const clientIsRemoved = (
          this.getClientStatusColor(client, pir) || ""
        ).includes(classForRemovedClient);
        return {
          ...client,
          name,
          clientIsRemoved,
          subscriptions,
        };
      });
    },
    getClientsAndPriority(pir) {
      const clients = this.getPIRClients(pir);
      const firstFive = clients.slice(0, 5);
      const clientsAfterFirstFive = clients.slice(5, clients.length);
      const clientsDisplay = firstFive.map((client) => {
        const name = client?.name;
        return `<span class="${this.getClientStatusColor(
          client,
          pir
        )}">${name}</span>`;
      });
      if (clientsAfterFirstFive.length) {
        clientsDisplay.push(`+${clientsAfterFirstFive.length} more`);
      }
      return clientsDisplay.join(", ");
    },
    getInputType(colIndex) {
      return colIndex === 3 ? "number" : "text";
    },
    onCellChange(value, pir, property) {
      if (!pir.id) return;
      this.$set(this.assignments, pir.id, {
        ...(this.assignments?.[pir?.id] || {}),
        pir,
        [property]: value,
      });
    },
  },
  watch: {
    currentPortfolio: {
      deep: true,
      immediate: true,
      handler(v) {
        const pirs = v?.pirSummary?.pirs || [];
        const dimensions = v?.portfolio?.dimensions || [];
        for (const dimension of dimensions) {
          const pirId = dimension?.dimensionId || null;
          if (!pirId) continue;
          const pirDetails = pirs.find((x) => x?.id === pirId);
          // console.log('pirDetails', pirDetails);
          const assignmentsFormatted = (dimension?.assignments || []).map(
            (x) => {
              const names = (x?.analyst || "").split(" ");
              return {
                ...x,
                surname: names?.[1],
                givenName: names?.[0],
                regionAssigned: x.audience,
                dateAssigned: x.assigned,
              };
            }
          );
          const analystByRegions = groupBy(assignmentsFormatted, "audience");
          this.$set(this.assignments, pirId, {
            ...analystByRegions,
            comments: dimension?.comments,
            assignedPriority: dimension?.assignedPriority,
            effort: dimension?.effort,
            pir: pirDetails,
          });
        }
      },
    },
  },
};
</script>

<style scoped>
/* ================= Global Variables ================= */
:root {
  --table-border: #ccc;
  --header-bg: #f5f5f5;
  --group-bg-start: rgba(0, 123, 255, 0.1);
  --group-bg-end: rgba(0, 123, 255, 0.2);
  --accent-bg-start: rgba(220, 53, 69, 0.1);
  --accent-bg-end: rgba(220, 53, 69, 0.2);
  --group-border-color: #666;
  --group-border-width: 2px;
}

/* ================= Base Table Styling ================= */
.data-table {
  width: 100%;
  border: 1px solid var(--table-border);
  border-collapse: collapse;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  margin: 0 auto;
  position: relative; /* for sticky positioning */
}

/* Ensure all cells have consistent borders */
.data-table th,
.data-table td {
  border: 1px solid var(--table-border);
}

/* Re-enable black borders override if needed */
.data-table-container .data-table th,
.data-table-container .data-table td {
  border: 1px solid #000;
}

/* ================= Sticky Header Enhancements ================= */
.data-table thead th {
  position: sticky;
  top: 0;
  background: #f0f0f0 !important;
  z-index: 10;
  padding: 10px 12px;
  text-align: center;
  border-bottom: 1px solid var(--table-border);
}

/* First header row */
.data-table thead .header-group-row th {
  top: 6vh;
  z-index: 11;
  border-top: 1px solid #000;
}

/* Second header row offset by first row height */
.data-table thead .header-detail-row th {
  top: 10vh; /* adjust to match .header-group-row height */
  z-index: 10;
  border-top: 1px solid #000;
}

/* ================= Header Styling ================= */
.header-group-row {
  background: var(--header-bg);
}

.header-detail-row {
  background: var(--header-bg);
}

.header-group {
  padding: 10px 0;
  font-weight: 700;
  text-align: center;
  color: #333;
}

.pir-group {
  background: linear-gradient(135deg, var(--group-bg-start), var(--group-bg-end));
}

.analysts-group {
  background: linear-gradient(135deg, var(--accent-bg-start), var(--accent-bg-end));
}

.header-cell {
  white-space: nowrap;
  font-weight: 600;
  color: #555;
}

/* ================= Group Borders ================= */
.header-detail-row th {
  border-bottom: var(--group-border-width) solid var(--group-border-color);
}

.data-table th:nth-child(4),
.data-table td:nth-child(4) {
  border-right: var(--group-border-width) solid var(--group-border-color);
}

.header-group-row th:first-child {
  border-right: var(--group-border-width) solid var(--group-border-color);
}

/* ================= Body Rows & Cells ================= */
.data-row:nth-child(even) {
  background: #fafafa;
}

.data-row:hover {
  background: #f1f1f1;
}

.data-row {
  transition: background 0.2s ease;
}

.data-cell {
  padding: 0;
  vertical-align: middle;
  position: relative;
}

.readonly-cell {
  background: #f0f0f0;
}

.new-cell {
  background: #fff !important;
}

.editable-cell {
  background: #fff;
  width: 12%;
}

.cell-input {
  width: 100%;
  border: none;
  padding: 10px 12px;
  background: transparent;
  font-size: 14px;
  color: #333;
  outline: none;
  min-height: 32px;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.cell-input:focus {
  background: #e9f5ff;
  box-shadow: inset 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.readonly-text {
  display: block;
  padding: 10px 12px;
  color: #666;
  font-weight: 600;
  min-height: 32px;
  line-height: 18px;
}

/* ================= Responsive Adjustments ================= */
@media (max-width: 768px) {
  .data-table-container {
    overflow-x: scroll;
  }
  .data-table {
    min-width: 900px;
  }
  .header-cell,
  .cell-input,
  .readonly-text {
    padding: 8px 10px;
    font-size: 12px;
  }
}

</style>